<h2>Notes de la session - <span class="noBold">{{data.session.dateLib}}</span></h2>

<ng-container *ngIf="!isLoading">
  <div *ngFor="let rating of ratings, let i = index">
    <p>
      <span class="bold">Note: </span>{{rating.rating}}
    </p>
    <p *ngIf="rating.email">
      <span class="bold">Email: </span>{{rating.email}}
    </p>
    <p *ngIf="rating.comment">
      <span class="bold">Commentaire: </span>
      <span class="italic">
        {{rating.comment}}
      </span>
    </p>
    <hr *ngIf="i + 1 < ratings.length && ratings.length > 1">
  </div>


</ng-container>

<mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>

<div class="btn_action">
  <button type="button" class="confirm" (click)="dialogRef.close()">Fermer</button>
</div>
